import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class EnsureAuthenticated implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (sessionStorage.getItem('bbx-token')) {
      return true;
    } else {
      this.router.navigateByUrl('/login');
      return false;
    }
  }
}
